/** Part C — Funder link resolution modal. */
import React, { useCallback } from 'react';
import { Landmark } from 'lucide-react';
import { LinkResolutionModal } from './ResolutionModalBase';

export default function FunderLinkResolutionModal({ open, onOpenChange, deal, onResolved }) {
  const filter = useCallback((c) => !!c.is_funder, []);
  return (
    <LinkResolutionModal
      open={open}
      onOpenChange={onOpenChange}
      deal={deal}
      title="Link Funder"
      description="Select an existing funder contact for this deal."
      icon={<Landmark className="h-4 w-4" />}
      fieldKey="funder_id"
      contactType="funder"
      contactFilter={filter}
      onResolved={onResolved}
      testidPrefix="resolve-funder-link"
    />
  );
}
